import React from 'react';

export default class NotFoundPage extends React.Component {
    render() {
        return <div className="not-found">Page Not Found</div>;
    }
}
